import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const PRODUCT_QUALIFICATION_MODULE = 'PRODUCT_QUALIFICATION_MANAGEMENT'

const routes: RouteRecordRaw[] = [
  {
    path: '/goods-management',
    name: 'GoodsManagement',
    component: Layout,
    meta: {
      title: '商品管理',
      icon: 'icon-product-qualification|svg',
      module: 'GOODS_MANAGMENT'
    },
    children: [
      {
        path: 'goods-info-management',
        name: 'GoodsInfoManagement',
        component: () => import('@/views/GoodsInfoManagement/index.vue'),
        meta: {
          title: '商品资料管理',
          module: 'GOODS_INFO_MANAGMENT'
        }
      },
      // 保留原 URL，挂到商品管理 Layout 下
      {
        path: '/product-qualification/management',
        name: 'ProductQualificationManagement',
        component: () => import('@/views/ProductQualificationManagement/index.vue'),
        meta: {
          title: '商品资质管理',
          showGuideIcon: true,
          module: PRODUCT_QUALIFICATION_MODULE
        }
      },
      {
        path: '/product-qualification/detail',
        name: 'ProductQualificationDetail',
        component: () => import('@/views/ProductQualificationDetail/index.vue'),
        meta: {
          title: '商品资质详情',
          module: PRODUCT_QUALIFICATION_MODULE,
          useModules: [PRODUCT_QUALIFICATION_MODULE],
          hidePageHeader: true,
          fullRedirectPath: true
        }
      }
    ]
  },
  // 兼容旧入口
  {
    path: '/product-qualification',
    redirect: '/product-qualification/management'
  }
]

export default routes
